<template>
    <div class="main-content">
        <section class="section">
          <div class="section-header">
            <h1>Detil Pengguna</h1>
            <div class="section-header-breadcumb button">
                <button class="btn btn-outline-danger" style="margin-right:5px" @click="deleteUser()"> <i class="fa fa-trash"></i> Hapus Pengguna</button>
            </div>
          </div>
        <div class="section-body">
            <h2 class="section-title">Detil Pengguna</h2>
            <p class="section-lead">Ubah informasi pengguna atau ubah password pengguna disini.</p>

            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h4>Informasi Utama</h4>
                        </div>
                        <div class="card-body">
                            <div class="form-group">
                                <label>* Username</label>
                                <input disabled type="text" v-model="username" required class="form-control">
                            </div>
                            <div class="form-group">
                                <label>* Nama User</label>
                                <input type="text" v-model="user_fullname" required class="form-control">
                            </div>
                            <div class="form-group">
                                <label>Role</label>
                                <select id="user_role" class="form-control select2">
                                    <option v-for="option in roleList" v-bind:key="option.id_level" :value="option.id_level" >{{ option.deskripsi_level}} </option>
                                </select>
                            </div>
                            <div class="form-group row">
                                <label class="col-sm-3 col-form-label">Aktifkan?</label>
                                <div class="col-sm-9">
                                    <toggle-button 
                                        style="display:block;"
                                        v-model="user_status" 
                                        :value="true" 
                                        color="#3DDCF7" :sync="true" 
                                        :labels="{checked: 'Ya', unchecked: 'Tidak'}"
                                        :width="80"
                                        :height="30"
                                        :font-size="14"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="col-12 text-center">
                    <button @click="$router.go(-1)" class="btn btn-danger">Kembali</button>
                    <button @click="showModal()" class="btn btn-info">Update Password</button>
                    <button @click="submit('normal')" class="btn btn-primary">Update Pengguna</button>
                </div>
            </div>
        </div>
        </section>
        <modal name="update-password" :height="180" width="80%">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <form @submit.prevent="updatePassword()">
                                <div class="form-group">
                                    <label>Password Baru</label>
                                    <input v-model="newPass" type="password" placeholder="Password Baru" required
                                            class="form-control">
                                </div>
                                <div class="text-center">
                                    <button type="submit" class="btn btn-success">
                                        Ubah Password
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>
<script>

export default {
    data() {
        return {
            id_user : this.$route.params.id_user,
            username : '',
            password : '',
            user_fullname : '',
            user_role : '',
            is_price : false,
            user_status : false,
            roleList : [],
            oldPass : '',
            newPass : '',
            conPass : ''
        }
    },
    mounted() {
        this.init();
        window.$(document).ready(function(){
            setTimeout(function(){ 
                $("#user_role").select2(); 
            }, 100);
        });
    },
    methods : {
        init: function () {
            this.$http.get('User/getRoleList').then( result => {
                if(result.data.code == '01') {
                    this.roleList = result.data.detail
                }
            })

            let that = this
            that.$http.get('user/getUserDetail/'+that.id_user).then( result => {
                if(result.data.code == '01') {
                    var detail = result.data.detail
                    that.username = detail.user_login,
                    that.user_fullname = detail.user_fullname,
                    that.user_role = detail.id_level,
                    that.user_status = detail.user_status == '1' ? true : false
                    var rl = parseInt(that.user_role)
                    console.log(rl);
                    setTimeout(function(){ 
                        $("#user_role").val(rl).trigger('change'); 
                    }, 200);
                }
            })
          
        },
        submit: function() {
            if(this.username == '') {
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Username harus diisi !',
                    type : 'warning'
                }   
                return false;
            }
            
            if(this.user_fullname == '') {
                this.$parent.toastr = {
                    title : 'Warning',
                    message: 'Nama User harus diisi !',
                    type : 'warning'
                }   
                return false;
            }

            this.$root.is_loading = true

            this.user_role = $("#user_role").select2('val')
            
            var formsub = new FormData()
            // formsub.append('user_login',this.username);
            formsub.append('user_fullname', this.user_fullname);
            formsub.append('id_level', this.user_role);
            formsub.append('user_status', this.user_status);

            this.$http.post('user/updateUser/'+this.id_user, formsub).then( result => {
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: 'User Berhasil Dibuat !',
                        type : 'success'
                    }
                    this.$router.go(-1);
                }else if(result.data.code == '02') {
                    this.$parent.toastr = {
                        title : 'Warning',
                        message: result.data.message,
                        type : 'warning'
                    }
                }
                this.$root.is_loading = false
            })

        },
        showModal: function() {
            this.$modal.show('update-password');
        },
        closeModal: function() {
            this.$modal.hide('update-password')
        },
        updatePassword: function() {
            this.$root.is_loading = true
            var formsub = new FormData()
            formsub.append('new_pass', this.newPass);
            this.$http.post('User/updatePassword/'+this.id_user,formsub).then(result => {
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: result.data.message,
                        type : 'success'
                    }
                    if(result.data.detail == true){
                        this.$modal.hide('update-password')
                    }
                }
                this.$root.is_loading = false
                this.newPass = ''
            })
        },
        deleteUser: function() {
            if(!confirm('Kamu yakin mau menghapus akun ini?')) {
                return false;
            }
            this.$root.is_loading = true
            this.$http.get('User/deleteUser/'+this.id_user).then(result => {
                if(result.data.code == '01') {
                    this.$parent.toastr = {
                        title : 'Success',
                        message: result.data.message,
                        type : 'success'
                    }
                    this.$router.go(-1)
                }
                this.$root.is_loading = false
            })
        }
    }
    
}
</script>


// WEBPACK FOOTER //
// src/components/user/UserDetail.vue